import apiClient from "./apiClient";

// Get all friends
export const getAllFriends = () => apiClient.get("/api/friend/all");

// Remove a friend
export const removeFriendById = (friendId) =>
  apiClient.delete(`/api/friend/remove/${friendId}`);

// Get all received friend requests
export const getReceivedRequests = () => apiClient.get("/api/friend/received");

// Accept a friend request
export const acceptFriendRequest = (id) =>
  apiClient.post(`/api/friend/accept/${id}`);

// Reject a friend request
export const rejectFriendRequest = (id) =>
  apiClient.post(`/api/friend/reject/${id}`);

// Search users by username or ID
export const searchUsers = (query) =>
  apiClient.get(`/api/user/search`, { params: { query } });

// Send a friend request
export const sendFriendRequestById = (id) =>
  apiClient.post(`/api/friend/send/${id}`);